<template>
    <div v-editable="blok">
        <StoryblokComponent
            v-for="(innerBlok, index) in blok.body as any[]"
            :key="(innerBlok as any)._uid"
            :blok="innerBlok as any"
            :index="index"
        />
        <div v-editable="blok" class="page">
            <StoryblokComponent
                v-for="(innerBlok, index) in blok.blocks"
                :key="(innerBlok as any)._uid"
                :blok="innerBlok as any"
                :index="index"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ArticlePageStoryblok } from '~/app/types/storyblok-types';

defineProps<{ blok: ArticlePageStoryblok }>();
</script>
